const E = 1e4, T = 6e4, I = void 0, M = void 0;
export {
  E as MESSAGE_TIMEOUT,
  M as MESSAGE_TIMEOUT_ERROR,
  I as MESSAGE_TIMEOUT_INFINITE,
  T as MESSAGE_TIMEOUT_LONG
};
